import CloseIcon from "@mui/icons-material/Close";
import {
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
} from "@mui/material";
import React from "react";

interface ISpecialInstructionsDialogProps {
  open: boolean;
  title: string;
  content: string;
  onClose: () => void;
}

const contentStyle: React.CSSProperties = {
  whiteSpace: "pre-wrap",
  wordBreak: "break-word",
  maxHeight: 320,
  overflowY: "auto",
};

const SpecialInstructionsDialog: React.FC<ISpecialInstructionsDialogProps> = ({
  open,
  title,
  content,
  onClose,
}) => {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
      <DialogTitle>
        <div className="page-header" data-testid="overage-entry-title">
          {title}
        </div>
        <IconButton
          aria-label="close"
          data-testid="special-instructions-close"
          onClick={onClose}
          sx={{ position: "absolute", right: 8, top: 8 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <div data-testid="special-instructions-content" style={contentStyle}>
          {content}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default SpecialInstructionsDialog;
